import { Plus } from "lucide-react";

interface FloatingAddButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export function FloatingAddButton({
  label,
  onClick,
  disabled
}: FloatingAddButtonProps): JSX.Element {
  return (
    <button className="fab" type="button" aria-label={label} onClick={onClick} disabled={disabled}>
      <Plus size={30} aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
